import { NgModule } from '@angular/core';

import { MatSliderModule } from '@angular/material/slider';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatListModule } from '@angular/material/list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DomSanitizer } from '@angular/platform-browser';
import { MatStepperModule } from '@angular/material/stepper';
@NgModule({
  exports: [
    MatInputModule,
    MatSliderModule,
    MatCardModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSnackBarModule,
    MatTabsModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatProgressBarModule,
    MatDialogModule,
    MatExpansionModule,
    MatTableModule,
    MatCheckboxModule,
    MatMenuModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatChipsModule,
    DragDropModule,
    MatListModule,
    MatAutocompleteModule,
    MatStepperModule,
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
})
export class MaterialModule {
  private icons = [
    { name: 'create-folder', path: 'svg/create-folder.svg' },
    { name: 'add-file', path: 'svg/add-file.svg' },
    { name: 'activities', path: 'svg/activities.svg' },
    { name: 'arrow', path: 'svg/arrow.svg' },
    { name: 'bid-item', path: 'svg/bid-item.svg' },
    { name: 'back-arrow', path: 'svg/back-arrow.svg' },
    { name: 'blue-plus', path: 'svg/blue-plus.svg' },
    { name: 'calendar', path: 'svg/calendar.svg' },
    { name: 'calender-light', path: 'svg/calender-light.svg' },
    { name: 'camera-outline', path: 'svg/camera-outline.svg' },
    { name: 'chevron-down', path: 'svg/chevron-down.svg' },
    { name: 'chevron-up', path: 'svg/chevron-up.svg' },
    { name: 'check', path: 'svg/check.svg' },
    { name: 'close', path: 'svg/close.svg' },
    { name: 'cross', path: 'svg/cross.svg' },
    { name: 'chevron-right', path: 'svg/chevron-right.svg' },
    { name: 'chevron-left', path: 'svg/chevron-left.svg' },
    { name: 'chevron-light', path: 'svg/chevron-light.svg' },
    { name: 'chevron-right-disabled', path: 'svg/chevron-right-disabled.svg' },
    { name: 'close', path: 'svg/close.svg' },
    { name: 'closed-issues', path: '/closed-issues.svg' },
    { name: 'daily-report-activity', path: 'svg/daily-report/daily-report-activity.svg' },
    { name: 'daily-report-bid-item', path: 'svg/daily-report/daily-report-bid-item.svg' },
    { name: 'daily-report-environmental', path: 'svg/daily-report/daily-report-environmental.svg' },
    { name: 'daily-report-forms', path: 'svg/daily-report/daily-report-forms.svg' },
    { name: 'daily-report-issues', path: 'svg/daily-report/daily-report-issues.svg' },
    { name: 'daily-report-labor-equipment', path: 'svg/daily-report/daily-report-labor-equipment.svg' },
    { name: 'daily-report-material-delivery', path: 'svg/daily-report/daily-report-material-delivery.svg' },
    { name: 'daily-report-material-testing', path: 'svg/daily-report/daily-report-material-testing.svg' },
    { name: 'daily-report-safety', path: 'svg/daily-report/daily-report-safety.svg' },
    { name: 'daily-report-weather', path: 'svg/daily-report/daily-report-weather.svg' },

    { name: 'daily-report-page-menu-bid-item', path: 'svg/daily-report/page-menu/daily-report-page-menu-bid-item.svg' },
    { name: 'daily-report-page-menu-delivery', path: 'svg/daily-report/page-menu/daily-report-page-menu-delivery.svg' },
    { name: 'daily-report-page-menu-usage', path: 'svg/daily-report/page-menu/daily-report-page-menu-usage.svg' },
    { name: 'daily-report-page-menu-external-test', path: 'svg/daily-report/page-menu/daily-report-page-menu-external-test.svg' },
    { name: 'daily-report-page-menu-internal-test', path: 'svg/daily-report/page-menu/daily-report-page-menu-internal-test.svg' },
    { name: 'daily-report-page-menu-issues', path: 'svg/daily-report/page-menu/daily-report-page-menu-issues.svg' },
    { name: 'daily-report-page-menu-activities', path: 'svg/daily-report/page-menu/daily-report-page-menu-activities.svg' },
    { name: 'daily-report-page-menu-labor', path: 'svg/daily-report/page-menu/daily-report-page-menu-labor.svg' },
    { name: 'daily-report-page-menu-equipment', path: 'svg/daily-report/page-menu/daily-report-page-menu-equipment.svg' },
    { name: 'daily-report-page-weather', path: 'svg/daily-report/page-menu/daily-report-page-weather.svg' },
    { name: 'daily-report-page-menu-forms', path: 'svg/daily-report/page-menu/daily-report-page-menu-forms.svg' },

    { name: 'delivery', path: 'svg/delivery.svg' },
    { name: 'dot', path: 'svg/dot.svg' },
    { name: 'error', path: 'svg/error.svg' },
    { name: 'filters', path: 'svg/filters.svg' },
    { name: 'flag', path: 'svg/flag.svg' },
    { name: 'full-screen', path: 'svg/full-screen.svg' },
    { name: 'form', path: 'svg/Form.svg' },
    { name: 'folder', path: 'svg/folder.svg' },
    { name: 'issues', path: 'svg/issues.svg' },
    { name: 'labor-equipment', path: 'svg/labor-equipment.svg' },
    { name: 'level-up', path: 'svg/level-up.svg' },
    { name: 'marker-outline', path: 'svg/marker-outline.svg' },
    { name: 'minus', path: 'svg/minus.svg' },
    { name: 'no-location', path: 'svg/no-location.svg' },
    { name: 'open-issues', path: '/open-issues.svg' },
    { name: 'paperclip', path: 'svg/paperclip.svg' },
    { name: 'pencil-outline', path: 'svg/pencil-outline.svg' },
    { name: 'plus', path: 'svg/plus.svg' },
    { name: 'profile', path: 'svg/profile.svg' },
    { name: 'quality', path: 'svg/quality.svg' },
    { name: 'search', path: 'svg/search.svg' },
    { name: 'sn-labor', path: '/sn_labor.svg' },
    { name: 'success-check', path: 'svg/success-check.svg' },
    { name: 'trash', path: 'svg/trash.svg' },
    { name: 'warning', path: 'svg/warning.svg' },
    { name: 'white-tick-with-green-background', path: 'svg/white-tick-with-green-background.svg' },
    { name: 'sn-labor', path: 'sn_labor.svg' },
    { name: 'top-nav-search', path: 'svg/top-nav-search.svg' },
    { name: 'closed-issues', path: 'closed-issues.svg' },
    { name: 'open-issues', path: 'open-issues.svg' },
    { name: 'add', path: 'add.svg' },
    { name: 'time-picker', path: 'svg/time-picker.svg' },
    { name: 'map-filters', path: 'map/filters-icon.svg' },
    { name: 'map-calendar', path: 'map/calendar-icon.svg' },
    { name: 'map-view', path: 'map/view-icon.svg' },
    // Type filter icons
    { name: 'type-bid-item', path: 'types/type-bid-item.svg' },
    { name: 'type-delivery', path: 'types/type-delivery.svg' },
    { name: 'type-activities', path: 'types/type-activities.svg' },
    { name: 'type-quality', path: 'types/type-quality.svg' },
    { name: 'type-issues', path: 'types/type-issues.svg' },
    { name: 'type-labor', path: 'types/type-labor.svg' },
    { name: 'green-check', path: 'svg/green-check.svg' },
    { name: 'red-cross', path: 'svg/red-cross.svg' },
    { name: 'genai', path: 'svg/genai.svg' },
    { name: 'fullscreen-expand', path: 'svg/fullscreen-expand.svg' },
    { name: 'fullscreen-collapse', path: 'svg/fullscreen-collapse.svg' },
    { name: 'failed-orange', path: 'svg/failed-orange.svg' },
    { name: 'markup-line', path: 'svg/markup-line.svg' },
    { name: 'markup-shape', path: 'svg/markup-shape.svg' },
    // Figma icon style (24px, 2px round stroke #060B1E); first used by the risk register.
    { name: 'download', path: 'svg/download.svg' },
    { name: 'upload', path: 'svg/upload.svg' },
    { name: 'lock', path: 'svg/lock.svg' },
    { name: 'lock-open', path: 'svg/lock-open.svg' },
    { name: 'arrow-right', path: 'svg/arrow-right.svg' },
    { name: 'check-circle', path: 'svg/check-circle.svg' },
    { name: 'undo', path: 'svg/undo.svg' },
    { name: 'heat-map', path: 'svg/heat-map.svg' },
  ];

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
  ) {
    // register custom icons from svg files
    this.icons.map(ic => {
      iconRegistry.addSvgIcon(
        ic.name,
        sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${ic.path}`));
    });

    // Excel (spreadsheet) icon as an inline literal so it can be used as a
    // <mat-icon svgIcon="excel-file"> and align inline like other mat-icons.
    iconRegistry.addSvgIconLiteral(
      'excel-file',
      sanitizer.bypassSecurityTrustHtml(
        '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,8L14,2M15.8,17H14L12,13.6L10,17H8.2L11,12.5L8.2,8H10L12,11.4L14,8H15.8L13,12.5L15.8,17Z" /></svg>'));
  }
}
